import axios from 'axios'
import router from '@/router/index'
import Vue from 'vue'
import utils from '@/common/utils'
import store from '@/store/index'
import {/* loginCb */logout} from '@/service/homeService'

var vm = new Vue()

const ajax = axios.create({
    // baseURL: 'https://vip.sohu.com',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
})

ajax.interceptors.request.use(
    config => {
        if(utils.getCookie("lt_ui_vip")){
            config.headers = {
                ...config.headers,
                'x-lt-ui-vip': utils.getCookie("lt_ui_vip")
            }
        }
        if (config.method.toLowerCase() == 'get') {
            config.params = {
                _: Date.now(),
                ...config.params
            }
        }
        return config
    },
    err => {
        return Promise.reject(err)
    }
)

// http response 拦截器
ajax.interceptors.response.use(
   async res => {
        let data = res.data
        if (data) {
            if (data.status === 601) {
                if (!document.getElementById('quickLogin')) {
                    if (utils.getCookie('vppinf') && utils.getStorage('username')) {
                        vm.$quickLogin()
                    } else {
                        router.replace({
                            path: '/login'
                        })
                    }
                    return Promise.reject(data)
                }
            }else{
                store.commit('login', true)
            }
            if(data.status === 602) {
                // await loginCb()
                logout().then(res => {
                    utils.setCookie("lt_ui_vip", '', undefined, '.vip.sohu.com')
                    localStorage.clear()
                    this.$store.commit('SAVE_SKIN', {})
                    $('.skin').remove()
                    router.replace({
                        path: '/login'
                    })
                })
            }
            if (data.status === 800||data.status === 500) {
                vm.$toast({
                    message: '系统错误，请刷新重试',
                    theme: 'danger'
                })
                return Promise.reject(data)
            } else if (data.status === 203) {
                // 邮箱冻结，不能登陆，只能续费
                router.push({
                    name: 'mediate',
                    query: {
                        s: 6
                    }
                })
            }else if (data.status === 208) {
                // 试用冻结，不能登陆，只能续费
                router.push({
                    name: 'mediate',
                    query: {
                        s: 0
                    }
                })
            }
            else if (data.status === 208) {
                router.push({
                    name: 'mediate',
                    query: {
                        s: 0
                    }
                })
            }
        }
        return data
    },
    error => {
        if (!utils.getCookie('vppinf')) {
            router.replace({
                path: '/login'
            })
        }
        return Promise.reject(error.data)
    }
)

export default ajax



// WEBPACK FOOTER //
// ./src/plugin/ajax.js